/// <amd-module name="Repos/Views/PullRequest/ActivityFeedShimService" />
import { IObservableValue, IReadonlyObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

const initialLastSeenRowIndex = 3;

export interface IActivityFeedShimService extends IVssService {
    disableShim(key: string, rowIndex?: number): void;
    getShimState(key: string, rowIndex?: number): IReadonlyObservableValue<boolean>;
    reset(): void;
}

class ActivityFeedShimService extends VssService implements IActivityFeedShimService {
    private lastSeenRowIndex = initialLastSeenRowIndex;
    private shimStates: { [key: string]: IObservableValue<boolean> } = {};

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);
    }

    public disableShim = (key: string, rowIndex?: number) => {
        if (rowIndex != undefined && this.lastSeenRowIndex < rowIndex) {
            this.lastSeenRowIndex = rowIndex;
        }

        const isShim = this.shimStates[key];

        if (isShim && isShim.value) {
            isShim.value = false;
        }
    };

    public getShimState = (key: string, rowIndex?: number): IReadonlyObservableValue<boolean> => {
        const shimState = this.shimStates[key];

        if (!shimState) {
            const newShimState = new ObservableValue<boolean>(rowIndex === undefined || rowIndex > this.lastSeenRowIndex);
            this.shimStates[key] = newShimState;
            return newShimState;
        }

        return shimState;
    };

    public reset = () => {
        this.lastSeenRowIndex = initialLastSeenRowIndex;
        Object.keys(this.shimStates).forEach(this.enableShim);
    };

    public enableShim = (key: string) => {
        const isShim = this.shimStates[key];

        if (isShim && !isShim.value) {
            isShim.value = true;
        }
    };
}

export function getActivityFeedShimService(pageContext: IVssPageContext): IActivityFeedShimService {
    return pageContext.getService<IActivityFeedShimService>("IActivityFeedShimService");
}

Services.add("IActivityFeedShimService", { serviceFactory: ActivityFeedShimService });
